import { useState } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Bunny Stream Video Player — iframe Embed Edition
 * Renders a signed Bunny Stream iframe URL.
 * Completely removes the native <video> tag to avoid Illegal constructor errors.
 */
export default function VideoPlayer({ streamUrl }) {


  if (!streamUrl) {
    return (
      <div className="w-full aspect-video bg-black rounded-md flex items-center justify-center">
        <p className="text-white">جاري تحميل مسار الفيديو...</p>
      </div>
    );
  }

  return (
    <div className="relative w-full aspect-video bg-black rounded-md overflow-hidden shadow-lg">
      <iframe
        src={streamUrl}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen={true}
        className="absolute inset-0 w-full h-full border-0"
        title="Bunny Stream Video Player"
      />
    </div>
  );
}
